import { render } from "./AdminMediaUpload.vue?vue&type=template&id=7205c825&scoped=true&ts=true"
import script from "./AdminMediaUpload.vue?vue&type=script&lang=ts"
export * from "./AdminMediaUpload.vue?vue&type=script&lang=ts"

import "./AdminMediaUpload.vue?vue&type=style&index=0&id=7205c825&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7205c825"]])

export default __exports__